import { combineReducers, compose, createStore as _createStore, applyMiddleware, CombinedState } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import { IApplicationState, TReduxActions, IThunkContext, IReduxStore } from '../../types/redux';

import {
  pageReducer,
  stickHeaderReducer,
  stickBottomReducer,
  feedbackReducer,
  publicationsReducer,
  graphsReducer,
  biReportsVideoUrlReducer,
} from '../../reducers';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  initialState: Pick<IApplicationState, 'page' | 'biReportsVideoUrl'>,
  debugEnabled: boolean,
  context: IThunkContext,
) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    page: pageReducer,
    stickHeader: stickHeaderReducer,
    stickBottom: stickBottomReducer,
    feedback: feedbackReducer,
    publications: publicationsReducer,
    graphs: graphsReducer,
    biReportsVideoUrl: biReportsVideoUrlReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context) as ThunkMiddleware<IApplicationState, TReduxActions>),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IApplicationState, {}>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
